module.exports = __webpack_public_path__ + "img/quit-manual.af414593.png";